import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { getDrafts, getForms } from "../../Forms/api";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Submitted-vs-draft counts for the user's RFQ forms (ViewEntries merges
// the same two fetches).
const MyFormsWidget = () => {
  const user = useSelector(selectUser);
  const [submitted, setSubmitted] = useState(null);
  const [drafts, setDrafts] = useState(null);

  useEffect(() => {
    if (!user?.userID) return;
    getForms((data) => setSubmitted(Array.isArray(data) ? data : []), user);
    getDrafts((data) => setDrafts(Array.isArray(data) ? data : []), user);
  }, [user?.userID]);

  return (
    <WidgetFrame title="My Forms" to="/forms/viewall">
      {submitted && drafts ? (
        <div className="grid grid-cols-2 gap-2">
          <WidgetStat value={submitted.length} label="Submitted" />
          <WidgetStat value={drafts.length} label="Drafts" />
        </div>
      ) : (
        <WidgetEmpty>Loading your forms…</WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default MyFormsWidget;
